var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "investment-assistant"
  }, [_c("section", {
    style: {
      background: `url(${_vm.imageUrl}) no-repeat center 0px`,
      backgroundSize: "cover"
    }
  }, [_c("Banner", {
    attrs: {
      imageUrl: _vm.imageUrl,
      title: _vm.bannerTitle,
      description: _vm.bannerText
    }
  })], 1), _c("section", {
    staticClass: "our-advantages"
  }, [_c("div", {
    staticClass: "our-advantages-main"
  }, [_c("Title", {
    attrs: {
      title: "我们的优势"
    }
  }), _c("div", {
    staticClass: "our-advantages-main-content"
  }, [_c("our-advanteges")], 1)], 1)]), _vm._l(_vm.moduleList, function (item, index) {
    return _c("Module", _vm._b({
      key: index,
      staticClass: "module-bg"
    }, "Module", item, false));
  }), _c("section", {
    staticClass: "user-stores"
  }, [_c("div", {
    staticClass: "user-stores-main"
  }, [_c("Title", {
    attrs: {
      title: "客户案例"
    }
  }), _c("ul", {
    staticClass: "list"
  }, _vm._l(_vm.userList, function (item, index) {
    return _c("li", {
      key: index,
      staticClass: "li-card"
    }, [_c("img", {
      attrs: {
        src: item.img,
        alt: "images"
      }
    }), _c("p", [_vm._v(_vm._s(item.desc))]), _c("img", {
      staticClass: "bg",
      attrs: {
        src: require("@/assets/images/service/investment-assistant/news-comma.png"),
        alt: "images"
      }
    })]);
  }), 0)], 1)]), _c("Appointment2")], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };